"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryLink = exports.LinkList = exports.DividerWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@vfuk/core-mixins");

var _coreInteraction = _interopRequireDefault(require("@vfuk/core-interaction"));

var _coreListItem = require("@vfuk/core-list-item");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LinkList = _styledComponents["default"].ul.withConfig({
  displayName: "LinkListstyle__LinkList",
  componentId: "sc-wjoroc-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;margin:0;padding:0;", "{display:flex;}", ""], _coreListItem.ListItemStyles.ListItem, props.level === 2 && (0, _styledComponents.css)(["background-color:", ";"], props.topNavigationTheme.appearance[props.appearance].topBar.links.subLink.backgroundColor));
});

exports.LinkList = LinkList;

var DividerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LinkListstyle__DividerWrapper",
  componentId: "sc-wjoroc-1"
})(function () {
  return (0, _styledComponents.css)(["", ";"], (0, _coreMixins.advancedSpacing)('padding', [2, 0]));
});

exports.DividerWrapper = DividerWrapper;
var SecondaryLink = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "LinkListstyle__SecondaryLink",
  componentId: "sc-wjoroc-2"
})(function (props) {
  return (0, _styledComponents.css)(["color:", ";", ";", ";"], props.topNavigationTheme.appearance[props.appearance].topBar.links.subLink.color, (0, _coreMixins.advancedSpacing)('padding', [2, 4]), _coreMixins.typography.paragraph(1, false));
});
exports.SecondaryLink = SecondaryLink;
//# sourceMappingURL=LinkList.style.js.map